import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  paddingTop: {
    paddingTop: theme.spacing(1),
  },
  badge: {
    margin: theme.spacing(2, 2, 0, 0),
  },
  margin: {
    margin: theme.spacing(0, 2, 0, 0),
  },
}));
